import React from "react";

import { Container } from "@components/Container/Container";

import styles from "./styles.module.scss";
import stylesHeading from "@components/Heading/styles.module.scss";
import { Box } from "@components/Box/Box";
import classnames from "classnames";
import Anime from "react-anime";
import { animeChildrenProps } from "@helpers/animations";
import { useInView } from "react-intersection-observer";
import { Heading } from "@components/Heading/Heading";
import {
  DownloadBox,
  DownloadBoxProps
} from "@components/DownloadBox/DownloadBox";

export interface DownloadsProps {
  downloads: DownloadBoxProps[];
  headline?: string;
  description?: string;
}

const Download: React.FC<DownloadsProps> = ({
  downloads,
  headline,
  description,
  ...props
}) => {
  const { ref, inView } = useInView({
    threshold: 0.2
  });
  return (
    <div
      ref={ref}
      className={classnames(styles.Download, styles.DownloadfocusGrid)}
      {...props}
    >
      <Container>
        {headline && (
          <Heading as="h2" className={stylesHeading.headingRibbon}>
            {headline}
          </Heading>
        )}
        {description && (
          <Box
            className={styles.paragraphText}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        <Box className={styles.gridFour}>
          {downloads &&
            downloads.map((download: DownloadBoxProps, index: number) => {
              if (!download.Media) return null;
              const animateEachChild = {
                ...animeChildrenProps,
                ...{ delay: (index * 100) / 1.5 },
                ...(inView ? { autoplay: true } : { autoplay: false })
              };
              return (
                <Box key={download.Key}>
                  <Anime {...animateEachChild}>
                    <DownloadBox
                      Media={download.Media}
                      ShowImage={download.ShowImage}
                    />
                  </Anime>
                </Box>
              );
            })}
        </Box>
      </Container>
    </div>
  );
};

export { Download };
